module.exports = __webpack_public_path__ + "img/blogger-image.a16ba6c1.png";